<template>
  <div class="app-container">
    <el-tabs v-model="active" @tab-click="handleClick" type="card" class="cardTabs">
      <el-tab-pane label="待审核信息" name="0">
        <review-list ref="reviewList">
          <template slot="column" v-if="$permission.canWrite()">
            <el-table-column label="操作" fixed="right" align="center" width="85">
              <template slot-scope="{row}">
                <el-button type="text" @click="checkById(row)">审核</el-button>
                <el-button type="text" @click="editById(row)">编辑</el-button>
              </template>
            </el-table-column>
          </template>
        </review-list>
      </el-tab-pane>
      <el-tab-pane label="成长活跃个人" name="1">
        <rankdata ref="rankdata">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button @click="onExport" type="primary" plain>导出</el-button>
          </template>
        </rankdata>
      </el-tab-pane>
      <el-tab-pane label="专业成长数据统计" name="2">
        <statdata ref="statdata">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button @click="onExport" type="primary" plain>导出</el-button>
          </template>
        </statdata>
      </el-tab-pane>
      <el-tab-pane label="学校教师结构" name="3">
        <structuredata ref="structuredata">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button @click="onExport" type="primary" plain>导出</el-button>
          </template>
        </structuredata>
      </el-tab-pane>
      <el-tab-pane label="重大推优备忘录" name="4">
        <recommend ref="recommend">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button @click="onExport" type="primary" plain>导出</el-button>
          </template>
        </recommend>
      </el-tab-pane>
    </el-tabs>
    <!-- 育人工作 -->
    <tj-edit-dialog1
      ref="tjEditDialog1"
      @close-saved="reload"
      @details-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
    />
    <tj-edit-dialog2
      ref="tjEditDialog2"
      @close-saved="reload"
      @details-saved="reload"
      :ThemeLvList="ThemeLvList"
      :restaurants="restaurants"
    />
    <tj-edit-dialog3
      ref="tjEditDialog3"
      @close-saved="reload"
      @details-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :awardsList="awardsList"
      :GradeList="GradeList"
    />
    <tj-edit-dialog4
      ref="tjEditDialog4"
      @close-saved="reload"
      @details-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :commendList="commendList"
      :GradeList="GradeList"
    />
    <!-- 课程教学 -->
    <cs-edit-dialog1
      ref="csEditDialog1"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
    ></cs-edit-dialog1>
    <cs-edit-dialog2
      ref="csEditDialog2"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :awardsList="awardsList"
      :GradeList="GradeList"
    ></cs-edit-dialog2>
    <cs-edit-dialog3
      ref="csEditDialog3"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :awardsList="awardsList"
      :GradeList="GradeList"
    ></cs-edit-dialog3>
    <cs-edit-dialog4
      ref="csEditDialog4"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :commendList="commendList"
      :GradeList="GradeList"
    ></cs-edit-dialog4>
    <!-- 教科研 -->
    <st-edit-dialog1
      ref="stEditDialog1"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :teamList="teamList"
      :CategoryList="CategoryList"
    ></st-edit-dialog1>
    <st-edit-dialog2
      ref="stEditDialog2"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :projectList="zdjsxmmc"
      :CategoryList="CategoryList"
    ></st-edit-dialog2>
    <st-edit-dialog3
      ref="stEditDialog3"
      @close-saved="reload"
      :ThemeLvList="ThemeLvList"
      :CategoryList="CategoryList"
      :writeList="writeList"
    ></st-edit-dialog3>
    <st-edit-dialog4
      ref="stEditDialog4"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :GradeList="GradeList"
      :CategoryList="CategoryList"
    ></st-edit-dialog4>
    <!-- 示范引领 -->
    <ds-edit-dialog1
      ref="dsEditDialog1"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :teamList="teamList"
      :CategoryList="CategoryList"
    ></ds-edit-dialog1>
    <ds-edit-dialog2
      ref="dsEditDialog2"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :projectList="zdjsxmmc"
      :GradeList="GradeList"
      :CategoryList="CategoryList"
    ></ds-edit-dialog2>
    <ds-edit-dialog3
      ref="dsEditDialog3"
      @close-saved="reload"
      :ThemeLvList="ThemeLvList"
      :GradeList="GradeList"
      :CategoryList="CategoryList"
    ></ds-edit-dialog3>
    <ds-edit-dialog4
      ref="dsEditDialog4"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :honorList="honorList"
      :GradeList="GradeList"
    ></ds-edit-dialog4>
    <!-- 指导学生 -->
    <gd-edit-dialog
      ref="gdEditDialog"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :GradeList="GradeList"
      :CategoryList="CategoryList"
      :projectList="zdxsxmmc"
    ></gd-edit-dialog>
    <!-- 学习培训 -->
    <ta-edit-dialog
      ref="taEditDialog"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :Theme2List="Theme2List"
      :ThemeLvList="ThemeLvList"
      :GradeList="GradeList"
      :projectList="projectList"
    ></ta-edit-dialog>
    <!-- 重大推优 -->
    <ec-edit-dialog
      ref="ecEditDialog"
      @close-saved="reload"
      :ThemeList="ThemeList"
      :ThemeLvList="ThemeLvList"
      :GradeList="GradeList"
      :projectList="projectList"
    ></ec-edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import reviewList from "@/components/gd/common/reviewList"; //待审核信息
import rankdata from "@/components/gd/common/rankdata"; //成长活跃个人
import statdata from "@/components/gd/common/statdata"; //专业成长数据统计
import structuredata from "@/components/gd/common/structuredata"; //学校教师结构
import recommend from "@/components/gd/common/recommend"; //重大推优备忘录
import tjEditDialog1 from "@/components/gd/teachjob/list/editDialog"; //育人工作 - 主题班会
import tjEditDialog2 from "@/components/gd/teachjob/list2/editDialog2"; //育人工作 - 个人德育类荣誉
import tjEditDialog3 from "@/components/gd/teachjob/list3/editDialog"; //育人工作 - 个人德育类获奖
import tjEditDialog4 from "@/components/gd/teachjob/list4/editDialog"; //育人工作 - 所带班级表彰获奖

import csEditDialog1 from "@/components/gd/coursestudy/list/editDialog"; //课程教学 - 公开课
import csEditDialog2 from "@/components/gd/coursestudy/list2/editDialog"; //课程教学 - 教学1类竞赛获奖
import csEditDialog3 from "@/components/gd/coursestudy/list3/editDialog"; //课程教学 - 教学2类竞赛获奖
import csEditDialog4 from "@/components/gd/coursestudy/list4/editDialog"; //课程教学 - 教学类荣誉

import stEditDialog1 from "@/components/gd/scientific/list/editDialog"; //教科研 - 论文发表
import stEditDialog2 from "@/components/gd/scientific/list2/editDialog"; //教科研 - 教育科研项目
import stEditDialog3 from "@/components/gd/scientific/list3/editDialog"; //教科研 - 著作出版
import stEditDialog4 from "@/components/gd/scientific/list4/editDialog"; //教科研 - 教育教学科研成果奖

import dsEditDialog1 from "@/components/gd/demonstrate/list/editDialog"; //示范引领 - 参加学术团体
import dsEditDialog2 from "@/components/gd/demonstrate/list2/editDialog"; //示范引领 - 指导教师
import dsEditDialog3 from "@/components/gd/demonstrate/list3/editDialog"; //示范引领 - 专题讲座
import dsEditDialog4 from "@/components/gd/demonstrate/list4/editDialog"; //示范引领 - 综合性荣誉称号

import gdEditDialog from "@/components/gd/guidance/list4/editDialog"; //指导学生
import taEditDialog from "@/components/gd/training/list4/editDialog"; //学习培训
import ecEditDialog from "@/components/gd/elect/list4/editDialog"; //重大推优

export default {
  name: "common",
  mixins: [curdMixins],
  components: {
    reviewList,
    rankdata,
    statdata,
    structuredata,
    recommend,
    tjEditDialog1,
    tjEditDialog2,
    tjEditDialog3,
    tjEditDialog4,
    csEditDialog1,
    csEditDialog2,
    csEditDialog3,
    csEditDialog4,
    stEditDialog1,
    stEditDialog2,
    stEditDialog3,
    stEditDialog4,
    dsEditDialog1,
    dsEditDialog2,
    dsEditDialog3,
    dsEditDialog4,
    gdEditDialog,
    taEditDialog,
    ecEditDialog,
  },
  data() {
    return {
      active: "0",
      base_api: require("@/api/gd/basedata").default,
      ThemeList: [],Theme2List: [],
      ThemeLvList: [],
      GradeList: [],
      restaurants: [],
      awardsList: [],
      commendList: [],
      teamList: [],
      projectList: [],
      zdjsxmmc: [], //指导教师项目名称
      zdxsxmmc: [], //指导学生项目名称
      CategoryList: [],
      writeList: [],
      honorList: [],
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    this.base_api.list({ Status: 1 }).then((res) => {
      if (res.Code == 0) {
        this.ThemeList = res.Data.filter((x) => x.ClassName == "类型");
        this.Theme2List = res.Data.filter((x) => x.ClassName == "培训类型");
        this.ThemeLvList = res.Data.filter((x) => x.ClassName == "级别");
        this.GradeList = res.Data.filter((x) => x.ClassName == "等次");
        var data1 = res.Data.filter((x) => x.ClassName == "德育类荣誉名称");
        this.restaurants = data1.map((x) => {
          return { value: x.DataName, DataName: x.DataName };
        });
        var data2 = res.Data.filter((x) => x.ClassName == "德育类奖项名称");
        this.awardsList = data2.map((x) => {
          return { value: x.DataName, DataName: x.DataName };
        });
        var data3 = res.Data.filter((x) => x.ClassName == "德育类表彰名称");
        this.commendList = data3.map((x) => {
          return { value: x.DataName, DataName: x.DataName };
        });
        var data4 = res.Data.filter((x) => x.ClassName == "团体名称");
        this.teamList = data4.map((x) => {
          return { value: x.DataName, DataName: x.DataName };
        });
        var data5 = res.Data.filter((x) => x.ClassName == "培训活动主题");
        this.projectList = data5.map((x) => {
          return { value: x.DataName, DataName: x.DataName };
        });
        var data6 = res.Data.filter((x) => x.ClassName == "类别");
        this.CategoryList = data6.map((x) => {
          return { value: x.DataName, DataName: x.DataName };
        });
        var data7 = res.Data.filter((x) => x.ClassName == "本人撰写部分");
        this.writeList = data7.map((x) => {
          return { value: x.DataName, DataName: x.DataName };
        });
        var data8 = res.Data.filter((x) => x.ClassName == "综合性荣誉名称");
        this.honorList = data8.map((x) => {
          return { value: x.DataName, DataName: x.DataName };
        });
        var zdjsxmmc = res.Data.filter((x) => x.ClassName == "指导教师项目名称");
        this.zdjsxmmc = zdjsxmmc.map((x) => {
          return { value: x.DataName, DataName: x.DataName };
        });
        var zdxsxmmc = res.Data.filter((x) => x.ClassName == "指导学生项目名称");
        this.zdxsxmmc = zdxsxmmc.map((x) => {
          return { value: x.DataName, DataName: x.DataName };
        });
      }
    });
  },
  methods: {
    handleClick(e) {
      this.reload();
    },
    reload() {
      if (this.active == "0") this.$refs.reviewList.getData();
      if (this.active == "1") this.$refs.rankdata.getData();
      if (this.active == "2") this.$refs.statdata.getData();
      if (this.active == "3") this.$refs.structuredata.getData();
      if (this.active == "4") this.$refs.recommend.getData();
    },
    onExport() {
      // console.log("导出");
      if (this.active == "1") this.$refs.rankdata.onExport();
      if (this.active == "2") this.$refs.statdata.onExport();
      if (this.active == "3") this.$refs.structuredata.onExport();
      if (this.active == "4") this.$refs.recommend.onExport();
    },
    checkById(row) {
      var class_list = require("./class.json");
      var class1 = class_list.find((x) => x.name == row.Class1);
      var class2 = class1.child.find((x) => x.item == row.Class2);
      // console.log("class", class1, class2);

      sessionStorage.setItem("check", "1");
      if (class2) this.$refs[class2.value].openEditById(row.RecordId);
      else this.$refs[class1.value].openEditById(row.RecordId);
    },
    editById(row) {
      // console.log("编辑", row);
      var class_list = require("./class.json");
      var class1 = class_list.find((x) => x.name == row.Class1);
      var class2 = class1.child.find((x) => x.item == row.Class2);
      // console.log("class", class1, class2);

      if (class2) this.$refs[class2.value].openEditById(row.RecordId);
      else this.$refs[class1.value].openEditById(row.RecordId);
    },
  },
};
</script>